<template>
  <div style="height: 100%;">
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from '../../echarts/pie.vue'
export default {
  data () {
    return {
      cdata: {
        xData: ["无退化", "轻度退化", "中度退化", "重度退化"],
        seriesData: [
        {
                value: 46004.65,
                name: "轻度退化"
              },
              {
                value: 8410.24,
                name: "中度退化"
              },

              {
                value: 45310.85,
                name: "无退化"
              },
              {
                value: 100,
                name: "重度退化"
              }
        ]
      }
    }
  },
  components: {
    Chart,
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>